import React from 'react';

import styles from './Nav.module.scss';

const Nav = (props) => (
  <div className={`${styles.Nav}`}>
    <a className={props.activeNav === 'ecuador' && styles.active} href="#Ecuador">Ecuador</a>
    <a className={props.activeNav === 'brazil' && styles.active} href="#Brazil">Brazil</a>
    { /* <a className={props.activeNav === 'senegal' && styles.active} href="#Senegal">Senegal</a> */ }
    <a className={props.activeNav === 'india' && styles.active} href="#India">India</a>
  </div>
)

export default Nav;



// WEBPACK FOOTER //
// ./src/components/ProgramOverview/Nav/index.js